require('./brokerHirePensionPlanDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @helpers
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
// @components
const BrokerThreeContainerSummary = require('components/broker/brokerThreeContainerSummary/brokerThreeContainerSummary');
// @ utilities
const { getFormattedString } = require('utilities/currencyHelper');
// @ constants
const { BROKER_CONTRIBUTION_PLAN_PERIODIC_ANUAL_REV_OPTION_NOREV_VALUE } = require('constants/index');
const {
    EURO_TEXT,
    DATE_FORMAT,
    DATE_FORMAT_WITH_DASHES
} = require('constants/index');
const ANNUAL_INCREMENT_OPTIONS = {
    1: 'brokerHirePlansStep1-annualIncrementPercentage',
    3: 'brokerHirePlansStep1-annualIncrementIPC',
    [BROKER_CONTRIBUTION_PLAN_PERIODIC_ANUAL_REV_OPTION_NOREV_VALUE]: 'brokerHirePlansStep1-withoutAnnualIncrement'
};


const BrokerHirePensionPlanDetails = props => {
    const {
        accountNumber,
        annualIncrement,
        annualIncrementPercentage,
        initialContribution,
        orderDate,
        participant,
        pensionPlanGestor,
        pensionPlanName,
        pensionPlanVocation,
        periodicity,
        periodicityDate,
        isPeriodicContributionAvailable,
        periodicityAmount
    } = props;

    let data =  {
        leftContainer: [],
        middleContainer: [],
        rightContainer: []
    };

    const amountFormatted = getFormattedString({
        amount: initialContribution,
        currency: EURO_TEXT
    });
    const orderDateToMoment = DateHelper.stringDateToMoment(orderDate, DATE_FORMAT_WITH_DASHES);
    const orderDateFormatted = DateHelper.formatDate(orderDateToMoment, DATE_FORMAT);

    data.leftContainer.push([formatText('brokerHirePlansDetails-planName'), pensionPlanName]);
    data.leftContainer.push([formatText('brokerHirePlansDetails-vocation'), pensionPlanVocation]);
    data.leftContainer.push([formatText('brokerHirePlansDetails-gestor'), pensionPlanGestor]);
    data.leftContainer.push([formatText('brokerHirePlansDetails-accountNumber'), accountNumber]);
    data.middleContainer.push([formatText('brokerHirePlansDetails-initialContribution'), amountFormatted]);
    data.middleContainer.push([formatText('brokerHirePlansDetails-orderDate'), orderDateFormatted]);
    data.middleContainer.push([formatText('brokerHirePlansDetails-participant'), participant]);

    if (isPeriodicContributionAvailable) {
        const periodicityAmountFormatted = getFormattedString({
            amount: periodicityAmount,
            currency: EURO_TEXT
        });
        const periodicityDateFormatted = DateHelper.formatDate(periodicityDate, DATE_FORMAT);
        const incrementOption = ANNUAL_INCREMENT_OPTIONS[annualIncrement];
        data.rightContainer.push([formatText('brokerHirePlansDetails-periodicContribution'), periodicityAmountFormatted]);
        data.rightContainer.push([formatText('brokerHirePlansDetails-initialDate'), periodicityDateFormatted]);
        data.rightContainer.push([formatText('brokerHirePlansDetails-periodicity'), periodicity]);
        data.rightContainer.push([formatText('brokerHirePlansDetails-annualIncrement'), formatText(incrementOption)]);
        if (annualIncrement === 1) {
            data.rightContainer.push([formatText('brokerHirePlansDetails-percentage'), annualIncrementPercentage]);
        }
    }

    return (
        <div className="hire-investment-details">
            <BrokerThreeContainerSummary
                data={data}
            />
        </div>
    );
};


BrokerHirePensionPlanDetails.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    annualIncrement: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    annualIncrementPercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    initialContribution: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orderDate: PropTypes.string.isRequired,
    participant: PropTypes.string.isRequired,
    pensionPlanGestor: PropTypes.string.isRequired,
    pensionPlanName: PropTypes.string.isRequired,
    pensionPlanVocation: PropTypes.string.isRequired,
    periodicity: PropTypes.string.isRequired,
    periodicityAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    periodicityDate: PropTypes.object.isRequired,
    isPeriodicContributionAvailable: PropTypes.bool.isRequired
};

module.exports = BrokerHirePensionPlanDetails;
